"use strict";

// adds " - SCORED" to sizeText
module.exports = function (accumulator) {
  var addition = '- SCORED';
  return accumulator + ' ' + addition;
};